var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJioPayStrip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "JioPay_Strip",
    "data-name": "JioPay Strip",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 292.591,
    height: 47.277,
    viewBox: "0 0 292.591 47.277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M0-78.723H292.591V-126H0Z",
    transform: "translate(0 126)",
    fill: "#006fb6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3404",
    "data-name": "Group 3404",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3239",
    "data-name": "Group 3239",
    transform: "translate(70.127 8.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M-5.831-2.916a1.751,1.751,0,0,1-1.75,1.751h0A1.751,1.751,0,0,1-9.333-2.915h0A1.751,1.751,0,0,1-7.582-4.667h0A1.751,1.751,0,0,1-5.831-2.916Z",
    transform: "translate(9.333 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3240",
    "data-name": "Group 3240",
    transform: "translate(78.882 8.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.582-1.165h0A1.751,1.751,0,0,1-9.334-2.915h0A1.751,1.751,0,0,1-7.583-4.667,1.751,1.751,0,0,1-5.832-2.916Z",
    transform: "translate(9.334 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3241",
    "data-name": "Group 3241",
    transform: "translate(87.637 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.334-2.916,1.751,1.751,0,0,1-7.583-4.667h0A1.751,1.751,0,0,1-5.832-2.916",
    transform: "translate(9.334 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3242",
    "data-name": "Group 3242",
    transform: "translate(96.392 8.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M-5.83-2.916A1.751,1.751,0,0,1-7.581-1.165h0a1.751,1.751,0,0,1-1.75-1.751h0a1.751,1.751,0,0,1,1.75-1.751A1.751,1.751,0,0,1-5.83-2.916Z",
    transform: "translate(9.332 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3243",
    "data-name": "Group 3243",
    transform: "translate(105.147 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916",
    transform: "translate(9.333 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3244",
    "data-name": "Group 3244",
    transform: "translate(113.902 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916",
    transform: "translate(9.333 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3245",
    "data-name": "Group 3245",
    transform: "translate(113.902 8.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165h0A1.751,1.751,0,0,1-9.333-2.915h0A1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916Z",
    transform: "translate(9.333 4.667)",
    fill: "#f5aa21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3246",
    "data-name": "Group 3246",
    transform: "translate(70.127 17.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.915h0A1.751,1.751,0,0,1-7.582-4.667h0A1.751,1.751,0,0,1-5.831-2.916Z",
    transform: "translate(9.333 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3247",
    "data-name": "Group 3247",
    transform: "translate(87.637 17.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.334-2.916,1.751,1.751,0,0,1-7.583-4.667h0A1.751,1.751,0,0,1-5.832-2.916",
    transform: "translate(9.334 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3248",
    "data-name": "Group 3248",
    transform: "translate(96.392 17.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M-5.83-2.916A1.751,1.751,0,0,1-7.581-1.165h0a1.75,1.75,0,0,1-1.75-1.751h0a1.75,1.75,0,0,1,1.75-1.751h0A1.751,1.751,0,0,1-5.83-2.916Z",
    transform: "translate(9.332 4.667)",
    fill: "#f5aa21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3249",
    "data-name": "Group 3249",
    transform: "translate(105.147 17.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916",
    transform: "translate(9.333 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3250",
    "data-name": "Group 3250",
    transform: "translate(70.127 26.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.915h0A1.751,1.751,0,0,1-7.582-4.667h0A1.751,1.751,0,0,1-5.831-2.916Z",
    transform: "translate(9.333 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3251",
    "data-name": "Group 3251",
    transform: "translate(78.882 26.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.583-1.165,1.751,1.751,0,0,1-9.334-2.916,1.751,1.751,0,0,1-7.583-4.667,1.751,1.751,0,0,1-5.832-2.916",
    transform: "translate(9.334 4.667)",
    fill: "#f5aa21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3252",
    "data-name": "Group 3252",
    transform: "translate(105.147 26.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916",
    transform: "translate(9.333 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3253",
    "data-name": "Group 3253",
    transform: "translate(70.127 35.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M-5.831-2.915a1.751,1.751,0,0,1-1.75,1.751h0a1.75,1.75,0,0,1-1.751-1.75h0A1.751,1.751,0,0,1-7.582-4.666,1.751,1.751,0,0,1-5.831-2.915",
    transform: "translate(9.333 4.666)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3254",
    "data-name": "Group 3254",
    transform: "translate(78.882 35.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M-5.832-2.915A1.751,1.751,0,0,1-7.582-1.164h0A1.751,1.751,0,0,1-9.334-2.915,1.751,1.751,0,0,1-7.583-4.666,1.751,1.751,0,0,1-5.832-2.915",
    transform: "translate(9.334 4.666)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3255",
    "data-name": "Group 3255",
    transform: "translate(87.637 35.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M-5.832-2.915a1.75,1.75,0,0,1-1.75,1.751h0A1.751,1.751,0,0,1-9.334-2.915,1.751,1.751,0,0,1-7.582-4.666,1.75,1.75,0,0,1-5.832-2.915",
    transform: "translate(9.334 4.666)",
    fill: "#f5aa21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3256",
    "data-name": "Group 3256",
    transform: "translate(96.392 35.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M-5.83-2.915a1.75,1.75,0,0,1-1.75,1.751h0a1.75,1.75,0,0,1-1.75-1.75h0a1.751,1.751,0,0,1,1.75-1.751h0A1.751,1.751,0,0,1-5.83-2.916Z",
    transform: "translate(9.332 4.666)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3257",
    "data-name": "Group 3257",
    transform: "translate(105.147 35.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    d: "M-5.831-2.915A1.751,1.751,0,0,1-7.582-1.164h0a1.75,1.75,0,0,1-1.751-1.75h0A1.751,1.751,0,0,1-7.582-4.666,1.751,1.751,0,0,1-5.831-2.915",
    transform: "translate(9.333 4.666)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3258",
    "data-name": "Group 3258",
    transform: "translate(113.902 35.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M-5.831-2.915a1.751,1.751,0,0,1-1.75,1.751h0a1.75,1.75,0,0,1-1.751-1.75h0A1.75,1.75,0,0,1-7.582-4.666,1.751,1.751,0,0,1-5.831-2.915",
    transform: "translate(9.333 4.666)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3259",
    "data-name": "Group 3259",
    transform: "translate(70.127 43.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916",
    transform: "translate(9.333 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3260",
    "data-name": "Group 3260",
    transform: "translate(87.637 43.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.334-2.916,1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.832-2.916",
    transform: "translate(9.334 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3261",
    "data-name": "Group 3261",
    transform: "translate(96.392 43.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    d: "M-5.83-2.916A1.751,1.751,0,0,1-7.581-1.165h0a1.751,1.751,0,0,1-1.75-1.75h0a1.751,1.751,0,0,1,1.75-1.751A1.751,1.751,0,0,1-5.83-2.916",
    transform: "translate(9.332 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3262",
    "data-name": "Group 3262",
    transform: "translate(105.147 43.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165h0A1.75,1.75,0,0,1-9.333-2.915h0A1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916",
    transform: "translate(9.333 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3263",
    "data-name": "Group 3263",
    transform: "translate(113.902 43.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165h0A1.75,1.75,0,0,1-9.333-2.915h0A1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916",
    transform: "translate(9.333 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3264",
    "data-name": "Group 3264",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.334-2.916,1.751,1.751,0,0,1-7.583-4.667h0A1.751,1.751,0,0,1-5.832-2.916",
    transform: "translate(9.334 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3265",
    "data-name": "Group 3265",
    transform: "translate(8.756 8.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    d: "M-5.83-2.916A1.751,1.751,0,0,1-7.581-1.165h0a1.751,1.751,0,0,1-1.75-1.751h0a1.751,1.751,0,0,1,1.75-1.751h0A1.751,1.751,0,0,1-5.83-2.916Z",
    transform: "translate(9.332 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3266",
    "data-name": "Group 3266",
    transform: "translate(17.51 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    "data-name": "Path 805",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667h0A1.751,1.751,0,0,1-5.831-2.916",
    transform: "translate(9.333 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3267",
    "data-name": "Group 3267",
    transform: "translate(0 17.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    "data-name": "Path 806",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.334-2.916,1.751,1.751,0,0,1-7.583-4.667h0A1.751,1.751,0,0,1-5.832-2.916",
    transform: "translate(9.334 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3268",
    "data-name": "Group 3268",
    transform: "translate(8.756 17.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    d: "M-5.83-2.916A1.751,1.751,0,0,1-7.581-1.165h0a1.75,1.75,0,0,1-1.75-1.751h0a1.75,1.75,0,0,1,1.75-1.751h0A1.751,1.751,0,0,1-5.83-2.916Z",
    transform: "translate(9.332 4.667)",
    fill: "#f5aa21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3269",
    "data-name": "Group 3269",
    transform: "translate(17.51 17.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667h0A1.751,1.751,0,0,1-5.831-2.916",
    transform: "translate(9.333 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3270",
    "data-name": "Group 3270",
    transform: "translate(17.51 26.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_809",
    "data-name": "Path 809",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667h0A1.751,1.751,0,0,1-5.831-2.916",
    transform: "translate(9.333 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3271",
    "data-name": "Group 3271",
    transform: "translate(0 35.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_810",
    "data-name": "Path 810",
    d: "M-5.832-2.915a1.75,1.75,0,0,1-1.75,1.751h0A1.751,1.751,0,0,1-9.334-2.915,1.751,1.751,0,0,1-7.582-4.666,1.75,1.75,0,0,1-5.832-2.915",
    transform: "translate(9.334 4.666)",
    fill: "#f5aa21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3272",
    "data-name": "Group 3272",
    transform: "translate(8.756 35.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_811",
    "data-name": "Path 811",
    d: "M-5.83-2.915a1.75,1.75,0,0,1-1.75,1.751h0a1.75,1.75,0,0,1-1.75-1.75h0a1.75,1.75,0,0,1,1.75-1.751h0A1.751,1.751,0,0,1-5.83-2.916Z",
    transform: "translate(9.332 4.666)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3273",
    "data-name": "Group 3273",
    transform: "translate(17.51 35.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    "data-name": "Path 812",
    d: "M-5.831-2.915a1.75,1.75,0,0,1-1.75,1.751h0a1.751,1.751,0,0,1-1.751-1.75h0A1.751,1.751,0,0,1-7.582-4.666h0A1.75,1.75,0,0,1-5.831-2.915",
    transform: "translate(9.333 4.666)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3274",
    "data-name": "Group 3274",
    transform: "translate(0 43.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.334-2.916,1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.832-2.916",
    transform: "translate(9.334 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3275",
    "data-name": "Group 3275",
    transform: "translate(8.756 43.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    d: "M-5.83-2.916A1.751,1.751,0,0,1-7.581-1.165h0a1.751,1.751,0,0,1-1.75-1.75h0a1.751,1.751,0,0,1,1.75-1.751A1.751,1.751,0,0,1-5.83-2.916",
    transform: "translate(9.332 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3276",
    "data-name": "Group 3276",
    transform: "translate(17.51 43.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.915h0A1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916",
    transform: "translate(9.333 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3277",
    "data-name": "Group 3277",
    transform: "translate(52.574 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916Z",
    transform: "translate(9.333 4.667)",
    fill: "#f5aa21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3278",
    "data-name": "Group 3278",
    transform: "translate(61.329 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667h0A1.751,1.751,0,0,1-5.831-2.916Z",
    transform: "translate(9.333 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3279",
    "data-name": "Group 3279",
    transform: "translate(52.574 17.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165h0A1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916Z",
    transform: "translate(9.333 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3280",
    "data-name": "Group 3280",
    transform: "translate(61.329 17.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.915h0A1.751,1.751,0,0,1-7.582-4.667h0A1.751,1.751,0,0,1-5.831-2.916Z",
    transform: "translate(9.333 4.667)",
    fill: "#f5aa21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3281",
    "data-name": "Group 3281",
    transform: "translate(61.329 26.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.915h0A1.751,1.751,0,0,1-7.582-4.667h0A1.751,1.751,0,0,1-5.831-2.916Z",
    transform: "translate(9.333 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3282",
    "data-name": "Group 3282",
    transform: "translate(52.574 35.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    d: "M-5.831-2.915a1.75,1.75,0,0,1-1.75,1.751h0A1.751,1.751,0,0,1-9.333-2.915h0A1.751,1.751,0,0,1-7.582-4.666a1.751,1.751,0,0,1,1.751,1.75Z",
    transform: "translate(9.333 4.666)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3283",
    "data-name": "Group 3283",
    transform: "translate(61.329 35.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    d: "M-5.831-2.915A1.751,1.751,0,0,1-7.582-1.164a1.75,1.75,0,0,1-1.751-1.75h0A1.751,1.751,0,0,1-7.582-4.666h0A1.751,1.751,0,0,1-5.831-2.915",
    transform: "translate(9.333 4.666)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3284",
    "data-name": "Group 3284",
    transform: "translate(61.329 43.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667h0A1.751,1.751,0,0,1-5.831-2.916",
    transform: "translate(9.333 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3285",
    "data-name": "Group 3285",
    transform: "translate(254.025 8.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    d: "M-5.831-2.916a1.751,1.751,0,0,1-1.75,1.751h0A1.751,1.751,0,0,1-9.333-2.915h0A1.751,1.751,0,0,1-7.582-4.667h0A1.751,1.751,0,0,1-5.831-2.916Z",
    transform: "translate(9.333 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3286",
    "data-name": "Group 3286",
    transform: "translate(262.78 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.583-1.165,1.751,1.751,0,0,1-9.334-2.916,1.751,1.751,0,0,1-7.583-4.667,1.751,1.751,0,0,1-5.832-2.916",
    transform: "translate(9.334 4.667)",
    fill: "#f5aa21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3287",
    "data-name": "Group 3287",
    transform: "translate(262.78 8.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.582-1.165h0A1.751,1.751,0,0,1-9.334-2.915h0A1.751,1.751,0,0,1-7.583-4.667,1.751,1.751,0,0,1-5.832-2.916Z",
    transform: "translate(9.334 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3288",
    "data-name": "Group 3288",
    transform: "translate(254.025 17.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.915h0A1.751,1.751,0,0,1-7.582-4.667h0A1.751,1.751,0,0,1-5.831-2.916Z",
    transform: "translate(9.333 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3289",
    "data-name": "Group 3289",
    transform: "translate(254.025 26.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.915h0A1.751,1.751,0,0,1-7.582-4.667h0A1.751,1.751,0,0,1-5.831-2.916Z",
    transform: "translate(9.333 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3290",
    "data-name": "Group 3290",
    transform: "translate(262.78 26.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.583-1.165,1.751,1.751,0,0,1-9.334-2.916,1.751,1.751,0,0,1-7.583-4.667,1.751,1.751,0,0,1-5.832-2.916",
    transform: "translate(9.334 4.667)",
    fill: "#f5aa21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3291",
    "data-name": "Group 3291",
    transform: "translate(254.025 35.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    d: "M-5.831-2.915a1.751,1.751,0,0,1-1.75,1.751h0a1.75,1.75,0,0,1-1.751-1.75h0A1.751,1.751,0,0,1-7.582-4.666h0A1.751,1.751,0,0,1-5.831-2.915",
    transform: "translate(9.333 4.666)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3292",
    "data-name": "Group 3292",
    transform: "translate(262.78 35.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    d: "M-5.832-2.915A1.751,1.751,0,0,1-7.582-1.164h0A1.751,1.751,0,0,1-9.334-2.915,1.751,1.751,0,0,1-7.583-4.666,1.751,1.751,0,0,1-5.832-2.915",
    transform: "translate(9.334 4.666)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3293",
    "data-name": "Group 3293",
    transform: "translate(254.025 43.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667h0A1.751,1.751,0,0,1-5.831-2.916",
    transform: "translate(9.333 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3294",
    "data-name": "Group 3294",
    transform: "translate(236.472 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916Z",
    transform: "translate(9.333 4.667)",
    fill: "#f5aa21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3295",
    "data-name": "Group 3295",
    transform: "translate(245.227 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916",
    transform: "translate(9.333 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3296",
    "data-name": "Group 3296",
    transform: "translate(236.472 17.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165h0A1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916Z",
    transform: "translate(9.333 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3297",
    "data-name": "Group 3297",
    transform: "translate(218.918 17.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165h0A1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916Z",
    transform: "translate(9.333 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3298",
    "data-name": "Group 3298",
    transform: "translate(245.227 17.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916",
    transform: "translate(9.333 4.667)",
    fill: "#f5aa21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3299",
    "data-name": "Group 3299",
    transform: "translate(245.227 26.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916",
    transform: "translate(9.333 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3300",
    "data-name": "Group 3300",
    transform: "translate(236.472 35.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    d: "M-5.831-2.915a1.751,1.751,0,0,1-1.75,1.751h0A1.751,1.751,0,0,1-9.333-2.915h0A1.751,1.751,0,0,1-7.582-4.666a1.751,1.751,0,0,1,1.751,1.75Z",
    transform: "translate(9.333 4.666)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3301",
    "data-name": "Group 3301",
    transform: "translate(245.227 35.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    d: "M-5.831-2.915A1.751,1.751,0,0,1-7.582-1.164h0a1.75,1.75,0,0,1-1.751-1.75h0A1.75,1.75,0,0,1-7.582-4.666,1.751,1.751,0,0,1-5.831-2.915",
    transform: "translate(9.333 4.666)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3302",
    "data-name": "Group 3302",
    transform: "translate(245.227 43.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165h0A1.75,1.75,0,0,1-9.333-2.915h0A1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916",
    transform: "translate(9.333 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3303",
    "data-name": "Group 3303",
    transform: "translate(35.02 35.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    d: "M0-2.916A1.751,1.751,0,0,1,1.75-4.667h0A1.751,1.751,0,0,1,3.5-2.917h0A1.751,1.751,0,0,1,1.751-1.165h0A1.751,1.751,0,0,1,0-2.915Z",
    transform: "translate(0 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3304",
    "data-name": "Group 3304",
    transform: "translate(26.265 35.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M0-2.916A1.751,1.751,0,0,1,1.75-4.667h0A1.751,1.751,0,0,1,3.5-2.916,1.751,1.751,0,0,1,1.751-1.165h0A1.751,1.751,0,0,1,0-2.915Z",
    transform: "translate(0 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3305",
    "data-name": "Group 3305",
    transform: "translate(35.02 26.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "M0-2.916A1.751,1.751,0,0,1,1.751-4.667,1.751,1.751,0,0,1,3.5-2.916h0A1.751,1.751,0,0,1,1.751-1.165h0A1.751,1.751,0,0,1,0-2.915Z",
    transform: "translate(0 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3306",
    "data-name": "Group 3306",
    transform: "translate(35.02 17.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    d: "M0-2.916A1.751,1.751,0,0,1,1.751-4.667,1.751,1.751,0,0,1,3.5-2.916h0A1.751,1.751,0,0,1,1.751-1.165h0A1.751,1.751,0,0,1,0-2.915Z",
    transform: "translate(0 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3307",
    "data-name": "Group 3307",
    transform: "translate(26.265 17.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M0-2.916A1.751,1.751,0,0,1,1.751-4.667,1.751,1.751,0,0,1,3.5-2.916,1.751,1.751,0,0,1,1.751-1.165,1.751,1.751,0,0,1,0-2.915Z",
    transform: "translate(0 4.667)",
    fill: "#f5aa21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3308",
    "data-name": "Group 3308",
    transform: "translate(35.02 8.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M0-2.916A1.751,1.751,0,0,1,1.75-4.667h0A1.75,1.75,0,0,1,3.5-2.917h0A1.751,1.751,0,0,1,1.751-1.165h0A1.751,1.751,0,0,1,0-2.916",
    transform: "translate(0 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3309",
    "data-name": "Group 3309",
    transform: "translate(26.265 8.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M0-2.916A1.751,1.751,0,0,1,1.75-4.667h0A1.751,1.751,0,0,1,3.5-2.916h0A1.751,1.751,0,0,1,1.751-1.165,1.751,1.751,0,0,1,0-2.916",
    transform: "translate(0 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3310",
    "data-name": "Group 3310",
    transform: "translate(43.819 43.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "M0-2.916A1.751,1.751,0,0,1,1.751-4.667,1.751,1.751,0,0,1,3.5-2.916,1.751,1.751,0,0,1,1.751-1.165,1.751,1.751,0,0,1,0-2.916",
    transform: "translate(0 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3311",
    "data-name": "Group 3311",
    transform: "translate(43.819 26.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    d: "M0-2.916A1.751,1.751,0,0,1,1.751-4.667,1.751,1.751,0,0,1,3.5-2.916,1.751,1.751,0,0,1,1.751-1.165,1.751,1.751,0,0,1,0-2.916",
    transform: "translate(0 4.667)",
    fill: "#f5aa21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3312",
    "data-name": "Group 3312",
    transform: "translate(43.819 17.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    d: "M0-2.916A1.751,1.751,0,0,1,1.751-4.667,1.751,1.751,0,0,1,3.5-2.916,1.751,1.751,0,0,1,1.751-1.165,1.751,1.751,0,0,1,0-2.916",
    transform: "translate(0 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3313",
    "data-name": "Group 3313",
    transform: "translate(43.819 8.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    d: "M0-2.916A1.751,1.751,0,0,1,1.75-4.667h0A1.75,1.75,0,0,1,3.5-2.917h0A1.751,1.751,0,0,1,1.751-1.165,1.751,1.751,0,0,1,0-2.916",
    transform: "translate(0 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3314",
    "data-name": "Group 3314",
    transform: "translate(43.819 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M0-2.916A1.751,1.751,0,0,1,1.751-4.667h0A1.751,1.751,0,0,1,3.5-2.916h0A1.751,1.751,0,0,1,1.751-1.165,1.751,1.751,0,0,1,0-2.916",
    transform: "translate(0 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3315",
    "data-name": "Group 3315",
    transform: "translate(175.187 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.583-1.165,1.751,1.751,0,0,1-9.334-2.916a1.75,1.75,0,0,1,1.75-1.751h0A1.751,1.751,0,0,1-5.832-2.916Z",
    transform: "translate(9.334 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3316",
    "data-name": "Group 3316",
    transform: "translate(175.187 8.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.582-1.165h0a1.751,1.751,0,0,1-1.751-1.75h0a1.751,1.751,0,0,1,1.75-1.751h0A1.751,1.751,0,0,1-5.832-2.916Z",
    transform: "translate(9.334 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3317",
    "data-name": "Group 3317",
    transform: "translate(183.942 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.583-1.165,1.751,1.751,0,0,1-9.334-2.916,1.751,1.751,0,0,1-7.583-4.667,1.751,1.751,0,0,1-5.832-2.916Z",
    transform: "translate(9.334 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3318",
    "data-name": "Group 3318",
    transform: "translate(192.697 8.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.582-1.165h0A1.751,1.751,0,0,1-9.334-2.916,1.751,1.751,0,0,1-7.583-4.667,1.751,1.751,0,0,1-5.832-2.916Z",
    transform: "translate(9.334 4.667)",
    fill: "#f5aa21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3319",
    "data-name": "Group 3319",
    transform: "translate(201.452 8.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.915h0A1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916",
    transform: "translate(9.333 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3320",
    "data-name": "Group 3320",
    transform: "translate(210.207 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.334-2.916,1.751,1.751,0,0,1-7.583-4.667h0A1.751,1.751,0,0,1-5.832-2.916Z",
    transform: "translate(9.334 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3321",
    "data-name": "Group 3321",
    transform: "translate(218.962 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667h0a1.75,1.75,0,0,1,1.751,1.75Z",
    transform: "translate(9.333 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3322",
    "data-name": "Group 3322",
    transform: "translate(218.962 8.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    d: "M-5.831-2.916a1.751,1.751,0,0,1-1.75,1.751h0A1.751,1.751,0,0,1-9.333-2.915h0A1.751,1.751,0,0,1-7.582-4.667h0a1.751,1.751,0,0,1,1.751,1.75Z",
    transform: "translate(9.333 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3323",
    "data-name": "Group 3323",
    transform: "translate(183.942 35.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    d: "M-5.832-2.915a1.75,1.75,0,0,1-1.75,1.751h0A1.751,1.751,0,0,1-9.334-2.915h0A1.751,1.751,0,0,1-7.583-4.666a1.751,1.751,0,0,1,1.751,1.75Z",
    transform: "translate(9.334 4.666)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3324",
    "data-name": "Group 3324",
    transform: "translate(192.697 35.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    d: "M-5.832-2.915A1.751,1.751,0,0,1-7.582-1.164h0A1.751,1.751,0,0,1-9.334-2.915,1.751,1.751,0,0,1-7.583-4.666a1.751,1.751,0,0,1,1.751,1.75Z",
    transform: "translate(9.334 4.666)",
    fill: "#f5aa21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3325",
    "data-name": "Group 3325",
    transform: "translate(201.405 35.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_864",
    "data-name": "Path 864",
    d: "M-5.832-2.915a1.751,1.751,0,0,1-1.75,1.751h0A1.751,1.751,0,0,1-9.334-2.915,1.751,1.751,0,0,1-7.583-4.666a1.751,1.751,0,0,1,1.751,1.75Z",
    transform: "translate(9.334 4.666)",
    fill: "#f5aa21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3326",
    "data-name": "Group 3326",
    transform: "translate(210.207 35.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    "data-name": "Path 865",
    d: "M-5.832-2.915a1.751,1.751,0,0,1-1.75,1.751h0a1.751,1.751,0,0,1-1.752-1.75h0A1.751,1.751,0,0,1-7.583-4.666h0A1.751,1.751,0,0,1-5.832-2.915",
    transform: "translate(9.334 4.666)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3327",
    "data-name": "Group 3327",
    transform: "translate(210.207 26.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_866",
    "data-name": "Path 866",
    d: "M-5.832-2.915a1.751,1.751,0,0,1-1.75,1.751h0A1.751,1.751,0,0,1-9.334-2.915h0A1.751,1.751,0,0,1-7.583-4.666h0A1.751,1.751,0,0,1-5.832-2.915",
    transform: "translate(9.334 4.666)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3328",
    "data-name": "Group 3328",
    transform: "translate(210.207 17.603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_867",
    "data-name": "Path 867",
    d: "M-5.832-2.915a1.751,1.751,0,0,1-1.75,1.751h0A1.751,1.751,0,0,1-9.334-2.915h0A1.751,1.751,0,0,1-7.583-4.666h0A1.751,1.751,0,0,1-5.832-2.915",
    transform: "translate(9.334 4.666)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3329",
    "data-name": "Group 3329",
    transform: "translate(183.942 43.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    "data-name": "Path 868",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.582-1.165h0A1.751,1.751,0,0,1-9.334-2.916,1.751,1.751,0,0,1-7.583-4.667,1.751,1.751,0,0,1-5.832-2.916",
    transform: "translate(9.334 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3330",
    "data-name": "Group 3330",
    transform: "translate(201.452 43.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.915h0A1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916",
    transform: "translate(9.333 4.667)",
    fill: "#f5aa21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3331",
    "data-name": "Group 3331",
    transform: "translate(210.207 43.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    "data-name": "Path 870",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.334-2.915h0A1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.832-2.916",
    transform: "translate(9.334 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3332",
    "data-name": "Group 3332",
    transform: "translate(218.962 43.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    d: "M-5.831-2.916a1.751,1.751,0,0,1-1.75,1.751h0A1.751,1.751,0,0,1-9.333-2.915h0A1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916",
    transform: "translate(9.333 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3333",
    "data-name": "Group 3333",
    transform: "translate(227.716 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.583-1.165,1.751,1.751,0,0,1-9.334-2.916,1.751,1.751,0,0,1-7.583-4.667,1.751,1.751,0,0,1-5.832-2.916Z",
    transform: "translate(9.334 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3334",
    "data-name": "Group 3334",
    transform: "translate(227.716 17.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    "data-name": "Path 873",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.583-1.165,1.751,1.751,0,0,1-9.334-2.916,1.751,1.751,0,0,1-7.583-4.667,1.751,1.751,0,0,1-5.832-2.916Z",
    transform: "translate(9.334 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3335",
    "data-name": "Group 3335",
    transform: "translate(227.716 35.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    "data-name": "Path 874",
    d: "M-5.832-2.915a1.751,1.751,0,0,1-1.75,1.751h0A1.751,1.751,0,0,1-9.334-2.915h0A1.751,1.751,0,0,1-7.583-4.666a1.751,1.751,0,0,1,1.751,1.75Z",
    transform: "translate(9.334 4.666)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3336",
    "data-name": "Group 3336",
    transform: "translate(227.717 26.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    d: "M0-2.916A1.751,1.751,0,0,1,1.751-4.667,1.751,1.751,0,0,1,3.5-2.916h0a1.751,1.751,0,0,1-1.75,1.751h0A1.751,1.751,0,0,1,0-2.915Z",
    transform: "translate(0 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3337",
    "data-name": "Group 3337",
    transform: "translate(227.716 43.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.582-1.165h0A1.751,1.751,0,0,1-9.334-2.916,1.751,1.751,0,0,1-7.583-4.667,1.751,1.751,0,0,1-5.832-2.916",
    transform: "translate(9.334 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3338",
    "data-name": "Group 3338",
    transform: "translate(122.657)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    d: "M-39.361,0A23.638,23.638,0,0,0-63,23.639,23.639,23.639,0,0,0-39.361,47.277,23.639,23.639,0,0,0-15.722,23.639,23.639,23.639,0,0,0-39.361,0",
    transform: "translate(62.999)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3339",
    "data-name": "Group 3339",
    transform: "translate(174.927 16.867)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_878",
    "data-name": "Path 878",
    d: "M-12.121-9.778a1.742,1.742,0,0,0,.615-1.495,1.779,1.779,0,0,0-.6-1.475,3,3,0,0,0-1.886-.479h-2.345v3.908h2.306a3.194,3.194,0,0,0,1.905-.459m1.475-5.3A3.771,3.771,0,0,1-9.073-13.52a4.684,4.684,0,0,1,.518,2.228,4.713,4.713,0,0,1-.527,2.257,3.754,3.754,0,0,1-1.583,1.553,5.388,5.388,0,0,1-2.58.567h-3.087v4.768H-19.4v-13.5h6.195a5.277,5.277,0,0,1,2.56.576",
    transform: "translate(19.4 15.65)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3340",
    "data-name": "Group 3340",
    transform: "translate(186.652 19.974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_879",
    "data-name": "Path 879",
    d: "M-8.981-9.665a4.447,4.447,0,0,0-1.935.332,1.15,1.15,0,0,0-.665,1.114,1.243,1.243,0,0,0,.42,1.025,1.758,1.758,0,0,0,1.143.342,2.439,2.439,0,0,0,1.123-.254,1.822,1.822,0,0,0,.772-.733A2.312,2.312,0,0,0-7.847-9v-.664ZM-7.847-11.7a2.265,2.265,0,0,0-.381-1.456,1.634,1.634,0,0,0-1.319-.459,2.222,2.222,0,0,0-1.251.293,1.231,1.231,0,0,0-.508.919h-2.756a2.731,2.731,0,0,1,1.31-2.276,6.126,6.126,0,0,1,3.341-.792,4.77,4.77,0,0,1,3.293.958A3.9,3.9,0,0,1-5.072-11.5v6.429h-2.5L-7.73-6.382h-.039A2.65,2.65,0,0,1-8.893-5.249a3.973,3.973,0,0,1-1.983.449,4.309,4.309,0,0,1-1.847-.371,2.729,2.729,0,0,1-1.221-1.095A3.342,3.342,0,0,1-14.374-8a2.728,2.728,0,0,1,1.3-2.5,7.138,7.138,0,0,1,3.723-.8h1.5Z",
    transform: "translate(14.374 15.469)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3341",
    "data-name": "Group 3341",
    transform: "translate(197.204 20.267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    d: "M-8.525-11.487h.039l2.111-6.9H-3.5L-6.981-8.673A6.9,6.9,0,0,1-8.457-6.045a4.39,4.39,0,0,1-1.9,1.2,8,8,0,0,1-2.238.293V-6.855a3.761,3.761,0,0,0,1.69-.322,1.862,1.862,0,0,0,.909-1.1l-3.654-10.1h2.951Z",
    transform: "translate(13.645 18.385)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3342",
    "data-name": "Group 3342",
    transform: "translate(128.885 12.054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_881",
    "data-name": "Path 881",
    d: "M-17.438-3.668h-.789c-1.495,0-2.312.843-2.312,2.53V7c0,2.094-.708,2.83-2.367,2.83a4.006,4.006,0,0,1-3.21-1.605,2.721,2.721,0,0,0-1.8,2.721c0,2.176,2.039,3.509,5.82,3.509,4.6,0,7.019-2.313,7.019-7.372V-1.138c0-1.687-.816-2.53-2.367-2.53M-10.316.44h-.545c-1.332,0-2.339.625-2.339,2.53v8.7c0,1.931.98,2.53,2.394,2.53h.544c1.333,0,2.284-.654,2.284-2.53V2.969c0-1.958-.924-2.53-2.339-2.53m-.3-6.31a2.432,2.432,0,0,0-2.747,2.449c0,1.523,1.088,2.475,2.829,2.475A2.438,2.438,0,0,0-7.786-3.422c0-1.523-1.088-2.449-2.829-2.449M.881.3C-3.581.3-6.545,3.133-6.545,7.349c0,4.326,2.855,7.1,7.344,7.1,4.461,0,7.4-2.775,7.4-7.073C8.2,3.133,5.288.3.881.3M.826,10.45a2.887,2.887,0,0,1-2.938-3.1A2.9,2.9,0,0,1,.826,4.275a2.9,2.9,0,0,1,2.938,3.1A2.926,2.926,0,0,1,.826,10.45",
    transform: "translate(27.911 5.871)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3343",
    "data-name": "Group 3343",
    transform: "translate(35.02 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_882",
    "data-name": "Path 882",
    d: "M0-2.916A1.751,1.751,0,0,1,1.751-4.667,1.751,1.751,0,0,1,3.5-2.916,1.751,1.751,0,0,1,1.751-1.165h0A1.751,1.751,0,0,1,0-2.916",
    transform: "translate(0 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3344",
    "data-name": "Group 3344",
    transform: "translate(271.535 43.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    "data-name": "Path 883",
    d: "M0-2.916A1.751,1.751,0,0,1,1.751-4.667,1.751,1.751,0,0,1,3.5-2.916,1.751,1.751,0,0,1,1.751-1.165,1.751,1.751,0,0,1,0-2.915Z",
    transform: "translate(0 4.667)",
    fill: "#f5aa21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3345",
    "data-name": "Group 3345",
    transform: "translate(271.535 26.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    "data-name": "Path 884",
    d: "M0-2.916A1.751,1.751,0,0,1,1.751-4.667h0A1.751,1.751,0,0,1,3.5-2.916,1.751,1.751,0,0,1,1.751-1.165,1.751,1.751,0,0,1,0-2.915Z",
    transform: "translate(0 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3346",
    "data-name": "Group 3346",
    transform: "translate(271.535 8.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    "data-name": "Path 885",
    d: "M0-2.916A1.751,1.751,0,0,1,1.75-4.667h0A1.751,1.751,0,0,1,3.5-2.916h0A1.751,1.751,0,0,1,1.751-1.165,1.75,1.75,0,0,1,0-2.915Z",
    transform: "translate(0 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3347",
    "data-name": "Group 3347",
    transform: "translate(289.089 8.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    d: "M-5.831-2.915a1.751,1.751,0,0,1-1.75,1.751h0A1.751,1.751,0,0,1-9.333-2.915h0A1.751,1.751,0,0,1-7.582-4.666h0A1.751,1.751,0,0,1-5.831-2.915",
    transform: "translate(9.333 4.666)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3348",
    "data-name": "Group 3348",
    transform: "translate(289.089 17.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    "data-name": "Path 887",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.915h0A1.751,1.751,0,0,1-7.582-4.667h0A1.751,1.751,0,0,1-5.831-2.916Z",
    transform: "translate(9.333 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3349",
    "data-name": "Group 3349",
    transform: "translate(289.089 26.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.915h0A1.751,1.751,0,0,1-7.582-4.667h0A1.751,1.751,0,0,1-5.831-2.916Z",
    transform: "translate(9.333 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3350",
    "data-name": "Group 3350",
    transform: "translate(289.089 35.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    d: "M-5.831-2.915a1.751,1.751,0,0,1-1.75,1.751h0a1.75,1.75,0,0,1-1.751-1.75h0A1.751,1.751,0,0,1-7.582-4.666,1.751,1.751,0,0,1-5.831-2.915",
    transform: "translate(9.333 4.666)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3351",
    "data-name": "Group 3351",
    transform: "translate(280.29 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667h0A1.751,1.751,0,0,1-5.831-2.916",
    transform: "translate(9.333 4.667)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3352",
    "data-name": "Group 3352",
    transform: "translate(70.127 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667h0A1.751,1.751,0,0,1-5.831-2.916Z",
    transform: "translate(9.333 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3353",
    "data-name": "Group 3353",
    transform: "translate(78.882 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.583-1.165,1.751,1.751,0,0,1-9.334-2.916,1.751,1.751,0,0,1-7.583-4.667,1.751,1.751,0,0,1-5.832-2.916",
    transform: "translate(9.334 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3354",
    "data-name": "Group 3354",
    transform: "translate(87.637 8.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.334-2.915h0A1.751,1.751,0,0,1-7.583-4.667h0A1.751,1.751,0,0,1-5.832-2.916Z",
    transform: "translate(9.334 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3355",
    "data-name": "Group 3355",
    transform: "translate(96.392 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M-5.83-2.916A1.751,1.751,0,0,1-7.582-1.165a1.751,1.751,0,0,1-1.75-1.751,1.75,1.75,0,0,1,1.75-1.751h0A1.751,1.751,0,0,1-5.83-2.916Z",
    transform: "translate(9.332 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3356",
    "data-name": "Group 3356",
    transform: "translate(105.147 8.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165h0A1.751,1.751,0,0,1-9.333-2.915h0A1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916Z",
    transform: "translate(9.333 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3357",
    "data-name": "Group 3357",
    transform: "translate(78.882 17.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.583-1.165,1.751,1.751,0,0,1-9.334-2.916,1.751,1.751,0,0,1-7.583-4.667,1.751,1.751,0,0,1-5.832-2.916",
    transform: "translate(9.334 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3358",
    "data-name": "Group 3358",
    transform: "translate(113.902 17.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916",
    transform: "translate(9.333 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3359",
    "data-name": "Group 3359",
    transform: "translate(87.637 26.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.334-2.916,1.751,1.751,0,0,1-7.583-4.667h0A1.751,1.751,0,0,1-5.832-2.916",
    transform: "translate(9.334 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3360",
    "data-name": "Group 3360",
    transform: "translate(96.392 26.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M-5.83-2.916A1.751,1.751,0,0,1-7.581-1.165h0a1.75,1.75,0,0,1-1.75-1.751h0a1.75,1.75,0,0,1,1.75-1.751h0A1.751,1.751,0,0,1-5.83-2.916Z",
    transform: "translate(9.332 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3361",
    "data-name": "Group 3361",
    transform: "translate(113.902 26.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916",
    transform: "translate(9.333 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3362",
    "data-name": "Group 3362",
    transform: "translate(78.882 43.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.582-1.165h0A1.751,1.751,0,0,1-9.334-2.916,1.751,1.751,0,0,1-7.583-4.667,1.751,1.751,0,0,1-5.832-2.916",
    transform: "translate(9.334 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3363",
    "data-name": "Group 3363",
    transform: "translate(0 8.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.334-2.915h0A1.751,1.751,0,0,1-7.583-4.667h0A1.751,1.751,0,0,1-5.832-2.916Z",
    transform: "translate(9.334 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3364",
    "data-name": "Group 3364",
    transform: "translate(8.756 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    d: "M-5.83-2.916A1.751,1.751,0,0,1-7.582-1.165a1.751,1.751,0,0,1-1.75-1.751,1.75,1.75,0,0,1,1.75-1.751h0A1.751,1.751,0,0,1-5.83-2.916Z",
    transform: "translate(9.332 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3365",
    "data-name": "Group 3365",
    transform: "translate(17.51 8.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.915h0A1.751,1.751,0,0,1-7.582-4.667h0A1.751,1.751,0,0,1-5.831-2.916Z",
    transform: "translate(9.333 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3366",
    "data-name": "Group 3366",
    transform: "translate(0 26.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.334-2.916,1.751,1.751,0,0,1-7.583-4.667h0A1.751,1.751,0,0,1-5.832-2.916",
    transform: "translate(9.334 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3367",
    "data-name": "Group 3367",
    transform: "translate(8.756 26.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    d: "M-5.83-2.916A1.751,1.751,0,0,1-7.581-1.165h0a1.75,1.75,0,0,1-1.75-1.751h0a1.75,1.75,0,0,1,1.75-1.751h0A1.751,1.751,0,0,1-5.83-2.916Z",
    transform: "translate(9.332 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3368",
    "data-name": "Group 3368",
    transform: "translate(52.574 8.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165h0A1.751,1.751,0,0,1-9.333-2.916a1.751,1.751,0,0,1,1.75-1.751h0A1.751,1.751,0,0,1-5.831-2.916Z",
    transform: "translate(9.333 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3369",
    "data-name": "Group 3369",
    transform: "translate(61.329 8.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    d: "M-5.831-2.916a1.751,1.751,0,0,1-1.75,1.751h0A1.751,1.751,0,0,1-9.333-2.915h0A1.751,1.751,0,0,1-7.582-4.667h0A1.751,1.751,0,0,1-5.831-2.916Z",
    transform: "translate(9.333 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3370",
    "data-name": "Group 3370",
    transform: "translate(52.574 26.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165h0A1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916Z",
    transform: "translate(9.333 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3371",
    "data-name": "Group 3371",
    transform: "translate(52.574 43.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165h0A1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916",
    transform: "translate(9.333 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3372",
    "data-name": "Group 3372",
    transform: "translate(254.025 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667h0A1.751,1.751,0,0,1-5.831-2.916Z",
    transform: "translate(9.333 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3373",
    "data-name": "Group 3373",
    transform: "translate(262.78 17.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.583-1.165,1.751,1.751,0,0,1-9.334-2.916,1.751,1.751,0,0,1-7.583-4.667,1.751,1.751,0,0,1-5.832-2.916",
    transform: "translate(9.334 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3374",
    "data-name": "Group 3374",
    transform: "translate(262.78 43.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.582-1.165h0A1.751,1.751,0,0,1-9.334-2.916,1.751,1.751,0,0,1-7.583-4.667,1.751,1.751,0,0,1-5.832-2.916",
    transform: "translate(9.334 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3375",
    "data-name": "Group 3375",
    transform: "translate(236.472 8.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165h0A1.751,1.751,0,0,1-9.333-2.916a1.751,1.751,0,0,1,1.75-1.751h0A1.751,1.751,0,0,1-5.831-2.916Z",
    transform: "translate(9.333 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3376",
    "data-name": "Group 3376",
    transform: "translate(245.227 8.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165h0A1.751,1.751,0,0,1-9.333-2.915h0A1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916Z",
    transform: "translate(9.333 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3377",
    "data-name": "Group 3377",
    transform: "translate(236.472 26.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165h0A1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916Z",
    transform: "translate(9.333 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3378",
    "data-name": "Group 3378",
    transform: "translate(218.918 26.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165h0A1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916Z",
    transform: "translate(9.333 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3379",
    "data-name": "Group 3379",
    transform: "translate(236.472 43.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165h0A1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916",
    transform: "translate(9.333 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3380",
    "data-name": "Group 3380",
    transform: "translate(35.02 43.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M0-2.916A1.751,1.751,0,0,1,1.751-4.667,1.751,1.751,0,0,1,3.5-2.916,1.751,1.751,0,0,1,1.751-1.165h0A1.751,1.751,0,0,1,0-2.915Z",
    transform: "translate(0 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3381",
    "data-name": "Group 3381",
    transform: "translate(26.265 43.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M0-2.916A1.751,1.751,0,0,1,1.751-4.667,1.751,1.751,0,0,1,3.5-2.916,1.751,1.751,0,0,1,1.751-1.165,1.751,1.751,0,0,1,0-2.915Z",
    transform: "translate(0 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3382",
    "data-name": "Group 3382",
    transform: "translate(26.265 26.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M0-2.916A1.751,1.751,0,0,1,1.751-4.667,1.751,1.751,0,0,1,3.5-2.916,1.751,1.751,0,0,1,1.751-1.165,1.751,1.751,0,0,1,0-2.915Z",
    transform: "translate(0 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3383",
    "data-name": "Group 3383",
    transform: "translate(26.265 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M0-2.916A1.751,1.751,0,0,1,1.751-4.667,1.751,1.751,0,0,1,3.5-2.916,1.751,1.751,0,0,1,1.751-1.165,1.751,1.751,0,0,1,0-2.916",
    transform: "translate(0 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3384",
    "data-name": "Group 3384",
    transform: "translate(43.819 35.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M0-2.916A1.751,1.751,0,0,1,1.751-4.667h0A1.751,1.751,0,0,1,3.5-2.916h0A1.751,1.751,0,0,1,1.751-1.165,1.751,1.751,0,0,1,0-2.915Z",
    transform: "translate(0 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3385",
    "data-name": "Group 3385",
    transform: "translate(183.942 8.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.582-1.165h0A1.751,1.751,0,0,1-9.334-2.916,1.751,1.751,0,0,1-7.583-4.667,1.751,1.751,0,0,1-5.832-2.916Z",
    transform: "translate(9.334 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3386",
    "data-name": "Group 3386",
    transform: "translate(192.697 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.583-1.165,1.752,1.752,0,0,1-9.334-2.916,1.751,1.751,0,0,1-7.583-4.667,1.751,1.751,0,0,1-5.832-2.916Z",
    transform: "translate(9.334 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3387",
    "data-name": "Group 3387",
    transform: "translate(201.452 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667h0A1.751,1.751,0,0,1-5.831-2.916",
    transform: "translate(9.333 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3388",
    "data-name": "Group 3388",
    transform: "translate(210.207 8.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M-5.832-2.916a1.751,1.751,0,0,1-1.75,1.751h0A1.751,1.751,0,0,1-9.334-2.915h0A1.751,1.751,0,0,1-7.583-4.667h0A1.751,1.751,0,0,1-5.832-2.916Z",
    transform: "translate(9.334 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3389",
    "data-name": "Group 3389",
    transform: "translate(175.187 35.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M-5.832-2.915A1.751,1.751,0,0,1-7.582-1.164h0a1.751,1.751,0,0,1-1.751-1.75h0a1.75,1.75,0,0,1,1.75-1.751h0a1.751,1.751,0,0,1,1.751,1.75Z",
    transform: "translate(9.334 4.666)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3390",
    "data-name": "Group 3390",
    transform: "translate(218.962 35.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M-5.831-2.915a1.75,1.75,0,0,1-1.75,1.751h0a1.75,1.75,0,0,1-1.751-1.75h0A1.751,1.751,0,0,1-7.582-4.666h0a1.751,1.751,0,0,1,1.751,1.75Z",
    transform: "translate(9.333 4.666)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3391",
    "data-name": "Group 3391",
    transform: "translate(175.187 43.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.582-1.165h0a1.751,1.751,0,0,1-1.751-1.75h0A1.751,1.751,0,0,1-7.583-4.667,1.751,1.751,0,0,1-5.832-2.916",
    transform: "translate(9.334 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3392",
    "data-name": "Group 3392",
    transform: "translate(192.697 43.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.582-1.165h0A1.752,1.752,0,0,1-9.334-2.916,1.752,1.752,0,0,1-7.583-4.667,1.751,1.751,0,0,1-5.832-2.916",
    transform: "translate(9.334 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3393",
    "data-name": "Group 3393",
    transform: "translate(227.716 8.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    d: "M-5.832-2.916A1.751,1.751,0,0,1-7.582-1.165h0A1.751,1.751,0,0,1-9.334-2.916,1.751,1.751,0,0,1-7.583-4.667h0A1.751,1.751,0,0,1-5.832-2.916Z",
    transform: "translate(9.334 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3394",
    "data-name": "Group 3394",
    transform: "translate(271.535 35.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M0-2.916A1.751,1.751,0,0,1,1.751-4.667h0A1.751,1.751,0,0,1,3.5-2.916h0a1.75,1.75,0,0,1-1.75,1.751h0A1.751,1.751,0,0,1,0-2.916",
    transform: "translate(0 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3395",
    "data-name": "Group 3395",
    transform: "translate(271.535 17.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    d: "M0-2.916A1.751,1.751,0,0,1,1.751-4.667h0A1.751,1.751,0,0,1,3.5-2.916,1.751,1.751,0,0,1,1.751-1.165,1.751,1.751,0,0,1,0-2.915Z",
    transform: "translate(0 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3396",
    "data-name": "Group 3396",
    transform: "translate(271.535 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M0-2.916A1.751,1.751,0,0,1,1.751-4.667h0A1.751,1.751,0,0,1,3.5-2.916,1.751,1.751,0,0,1,1.751-1.165,1.751,1.751,0,0,1,0-2.916",
    transform: "translate(0 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3397",
    "data-name": "Group 3397",
    transform: "translate(289.089 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667h0A1.751,1.751,0,0,1-5.831-2.916Z",
    transform: "translate(9.333 4.667)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3398",
    "data-name": "Group 3398",
    transform: "translate(280.29 8.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M-5.831-2.915A1.751,1.751,0,0,1-7.582-1.164,1.751,1.751,0,0,1-9.333-2.915h0A1.751,1.751,0,0,1-7.582-4.666h0a1.75,1.75,0,0,1,1.751,1.75Z",
    transform: "translate(9.333 4.666)",
    fill: "#006fb6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3399",
    "data-name": "Group 3399",
    transform: "translate(280.29 17.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667h0A1.751,1.751,0,0,1-5.831-2.916",
    transform: "translate(9.333 4.667)",
    fill: "#f5aa21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3400",
    "data-name": "Group 3400",
    transform: "translate(280.29 26.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667h0A1.751,1.751,0,0,1-5.831-2.916",
    transform: "translate(9.333 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3401",
    "data-name": "Group 3401",
    transform: "translate(280.29 35.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    d: "M-5.831-2.915a1.75,1.75,0,0,1-1.75,1.751h0a1.751,1.751,0,0,1-1.751-1.75h0A1.751,1.751,0,0,1-7.582-4.666h0A1.751,1.751,0,0,1-5.831-2.915",
    transform: "translate(9.333 4.666)",
    fill: "#4fbbab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3402",
    "data-name": "Group 3402",
    transform: "translate(280.29 43.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.915h0A1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916",
    transform: "translate(9.333 4.667)",
    fill: "#3bb5ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3403",
    "data-name": "Group 3403",
    transform: "translate(289.089 43.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M-5.831-2.916A1.751,1.751,0,0,1-7.582-1.165,1.751,1.751,0,0,1-9.333-2.916,1.751,1.751,0,0,1-7.582-4.667,1.751,1.751,0,0,1-5.831-2.916",
    transform: "translate(9.333 4.667)",
    fill: "#4fbbab"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJioPayStrip);
export default __webpack_public_path__ + "static/media/JioPay-Strip.c5fa2459c910ce0b8ec17b69f3d83d61.svg";
export { ForwardRef as ReactComponent };